import { GlobalSearchEntityType } from "../Others/GlobalSearch";
import { Optional } from "utility-types";
import { OpportunityStage } from "../Pipelines";

export interface ReportsResponse {
	data: Report[];
	filtered_count_map?: any;
}

export interface ReportData {
	groups: string[][];
	metrics: number[];
	metrics_by_currency?: Record<string, number[]>;
	reporting_currency?: string;
}

export interface ReportsListRequest {
	page: number;
	limit: number;
}

export enum ChartType {
	Line = "line",
	Column = "column",
	StackedColumn = "stacked_column",
	Funnel = "funnel",
	Pie = "pie",
	Kpis = "kpis",
	Tabular = "tabular",
	Gauge = "gauge"
}
export type ValidChartTypes =
	| ChartType.Line
	| ChartType.Column
	| ChartType.Funnel
	| ChartType.Pie;

export interface ChartComponentProps {
	group_by_0: GroupByField;
	group_by_1?: GroupByField | null;
	metric_0: ReportsMetric;
	metric_1?: ReportsMetric | null;
	data: ReportData;
}

export interface Report {
	name: string;
	chart_type: ValidChartTypes;
	company_id: string;
	created: string;
	data?: ReportData | null;
	entity_type: GlobalSearchEntityType;
	id: string;
	group_by_0: GroupByField;
	group_by_1?: GroupByField | null;
	is_system_generated: boolean | null;
	metric_0: ReportsMetric;
	metric_1?: ReportsMetric | null;
	filters: ReportFilter[];
	updated: string;
	user_id: string;
	group_by_currency?: boolean;
}

// https://stackoverflow.com/a/60128290
export type CreateReportFormStateInterface = Omit<
	Optional<Report, "group_by_0" | "group_by_1" | "metric_0" | "metric_1">,
	| "company_id"
	| "created"
	| "updated"
	| "id"
	| "user_id"
	| "is_system_generated"
>;
// Pick<Partial<Report>, 'group_by_0' | 'group_by_1' | 'metric_0' | 'metric_1'> {}

export class CreateReportFormState implements CreateReportFormStateInterface {
	name = "New Report";
	entity_type: GlobalSearchEntityType = GlobalSearchEntityType.Opportunity;
	filters: ReportFilter[] = [];
	chart_type: ValidChartTypes = ChartType.Line;
	group_by_0?: GroupByField;
	group_by_1?: GroupByField | null;
	metric_0?: ReportsMetric;
	metric_1?: ReportsMetric | null;
	group_by_currency?: boolean;
}

export interface ReportFilter {
	field: FieldValue;
	filter_operator: ReportField;
	values: ReportFilterValue[];
}

export interface GroupByField {
	field: FieldValue;
	time_accumulator?: ReportField;
}

export interface ReportsMetric {
	field: FieldValue;

	// not getting label here, its there in config
	accumulator: string;
}

export const chartsPalette: string[] = [
	"#FF6F42",
	"#BB6CF9",
	"#FFC12C",
	"#0076FF",
	"#23B899",
	"#8590B3",
	"#89C700",
	"#06E562",
	"#A904B7",
	"#334681",
	"#BAC6DD",
	"#EA0623",
	"#34D1BF",
	"#7676FF",
	"#E478FF",
	"#4CD9F9",
	"#FFE600",
	"#6C7293",
	"#3E3CA6",
	"#0A98B7",
	"#DCFF78",
	"#F94CD3",
	"#FF7880",
	"#662167"
];

// Create Report Config
export interface ReportConfig {
	data: ReportConfigModule[];
}

export interface ReportConfigModule {
	module: ModuleConfigOption;
	metrics: MetricConfigOption[];
	group_by: GroupByConfigOption[];
	filters: FilterConfigOption[];
	opportunity_stages: OpportunityStage[];
}

export enum ValidFilterDataTypes {
	Text = "Text",
	Number = "Number",
	Dropdown = "Dropdown",
	Entity = "Entity",
	Date = "Date"
}

export const CustomDateOperatorKey = "custom_date";
export interface FilterConfigOption {
	field: FieldValue;
	data_type: ValidFilterDataTypes;
	entity_type?: GlobalSearchEntityType;
	valid_operators: ReportField[];
	valid_values: ReportFilterValue[];
}

export interface GroupByConfigOption {
	field: FieldValue;
	valid_time_accumulators: ReportField[];
}

interface ReportFilterValue {
	id_value: string | number;
	display_value: string;
	group_name?: string;
}

export interface ReportField {
	key: string;
	display_value: string;
}

export interface MetricConfigOption {
	key: string;
	display_key: string;
	values: FieldValue[];
}

export interface FieldValue {
	field_id: string;
	display_value: string;
}

export interface ModuleConfigOption {
	key: GlobalSearchEntityType;
	display_value: string;
}

// Create Report Form State
// export interface ReportsFormMetric {
// 	field: Omit<ReportsField, 'display_value'>;
// 	accumulator: string;
// }

// export interface ReportFormGroupByField {
// 	field: Omit<ReportsField, 'display_value'>;
// 	time_accumulator?: string | null;
// }

// export interface ReportFormFilterValues {
// 	id_value: string;
// 	display_value: string;
// }
// export interface ReportFormFilter {
// 	field: Omit<ReportsField, 'display_value'>;
// 	filter_operator: string;
// 	values: ReportFormFilterValues[];
// }
